import axios from "@axios";
import moment from "moment-timezone";
import store from "@/store";
import { getUserData } from "@/auth/utils";
import {useUtils as useI18nUtils} from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
    helpdeskNotifications: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(ticket => ({
        value: ticket.id,
        label: ticket.name,
      }))
    },
    getItemsTicketOpen(state) {
      const userData = getUserData();
      const { t } = useI18nUtils();

      return state.helpdeskNotifications.map(ticket => ({
        id: ticket.id,
        title: ticket.subject,
        body: ticket.message,
        timestamp: moment(ticket.created_at).format("DD/MM/YYYY HH:mm:ss"),
        tag: (userData.email == ticket.from) ? t('helpdesk.ticket.owner') : ticket.from,
      }))
      
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setDataNotification(state, value) {
      state.helpdeskNotifications = value
    },
  },
  actions: {
    async export({commit}, params) {
      const response = await axios.get("v1/helpdesk/ticket", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });
      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        const {t} = useI18nUtils();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "Helpdesk Ticket",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Helpdesk Tickets",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async getAll({commit}, params) {
      const {data} = await axios.get('v1/helpdesk/ticket', {params})

      if (!data.success) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const {data} = await axios.post('v1/helpdesk/ticket', params, {
        headers: { "Content-Type": "multipart/form-data" }
      })

      return data
    },
    async edit(_, {id, params}) {
      const {data} = await axios.put(`v1/helpdesk/ticket/${id}`, params)

      return data
    },
    async delete(_, id) {
      const {data} = await axios.delete(`v1/helpdesk/ticket/${id}`)

      return data
    },
    async getAssigned({commit}, params) {
      const {data} = await axios.get('v1/helpdesk/ticket', {params})

      if (!data.success) {
        return []
      }
      commit('setDataNotification', data.data)
      return data
    },
    async thread(_, {id, params}) {
      const {data} = await axios.post(`v1/helpdesk/ticket/${id}/thread`, params, {
        headers: { "Content-Type": "multipart/form-data" }
      })

      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
